import React, { useContext } from 'react'
import CircularProgressWithLabel from '../CircularLoader'
import CircularProgressWithTimer from '../CircularLoaderTimer'
import { Typography } from '@mui/material'
import { useState, useEffect } from 'react';
import { Il8nContext } from '../../Helper/i18n';

export default function FullScreenLoader(props) {
  const { message, countDownTimer, secondsToLoad } = props
  const [progress, setProgress] = useState(0);
  const localeText = useContext(Il8nContext)

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress <= 0 ? 100 : prevProgress - secondsToLoad));
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <>
      {
        message ?
          <>
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: "9999",
              width: props?.width ? props?.width : "100vw",
              position: "absolute",
              background: "black",
              opacity: "70%",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              flexDirection: 'column'
            }}></div>

            <div style={{ backgroundColor: '#e2e1e1', borderRadius: '10px', padding: '30px 20px', textAlign: 'center', zIndex: "99999", position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "85%", maxWidth: "800px" }}>
              {
                countDownTimer ? <CircularProgressWithTimer value={progress} size={100} secondsToLoad={secondsToLoad} />
                  :
                  <>
                    {props?.loaderImage == undefined ? <img src={"images/loading Animation.gif"} alt="loading" style={{ width: "100px", height: "100px" }} /> : <CircularProgressWithLabel seconds={props.seconds} progress={props.progress} />}
                  </>
              }

              <Typography variant="h6" style={{ fontWeight: "bold", color: "#000", marginTop: "20px", }}>
                {!countDownTimer ? message ||  localeText?.documentUploadMessageUploading : localeText?.documentUploadMessageScanning || message}
              </Typography>
            </div>
          </>
          :
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: "9999",
            width: props?.width ? props?.width : "100vw",
            position: "absolute",
            // height: props?.height ? props?.height:"100vh",
            background: "black",
            opacity: "70%",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            flexDirection: 'column'
          }}>
            {props?.loaderImage == undefined ? <img src={"images/loading Animation.gif"} alt="loading" style={{ width: "100px", height: "100px" }} /> : <CircularProgressWithLabel seconds={props.seconds} progress={props.progress} />}
          </div>
      }
    </>
  )
}